import React, { useState, useEffect, useRef } from 'react';
import {
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Badge,
} from 'reactstrap';
import { DataTable, Column } from 'vivace-fluent-motion';
import { OverlayPanel } from 'primereact/overlaypanel';
import parse from 'html-react-parser';
import { Colxx } from '@common/customBootstrap';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '@containers/BaseConhecimento/store/base.action';
import * as CommonActions from '@common/common.action';
import WebapiCommon from '@common/util/webapi.common';
import IntlMessage from "../../helpers/intlMessage";

export default function PreviewBase({
  op,
  onRef,
  text,
  laudos,
  total,
  loading,
}) {
  const [selectedLaudo, setSelectedLaudo] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const page = useSelector((state) => state.baseConhecimento.page);
  const isMounted = useRef(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (isMounted.current) {
      op.current.hide();
      alert(selectedLaudo.name);
    }
  }, [selectedLaudo]);

  function toMarkDown(text, searchText) {
    const regex = new RegExp(searchText, 'gi');
    text = text.replace(/(<mark class="markdown">|<\/mark>)/gim, '');
    const newText = text.replace(regex, '<mark class="markdown">$&</mark>');
    return newText;
  }

  function setHighLight(data, texto, selected) {
    let temp = '';
    const index = data.toLowerCase().indexOf(texto.toLowerCase());
    //getAllIndexes(arr, val)
    temp = data;
    temp = toMarkDown(temp, texto);
    let limit = temp.length > 200 ? 200 : 0;
    if (limit > 0 && !selected) {
      let min = index - limit;
      let max = index + limit;
      min = min < 0 ? 0 : min;
      max = max < 200 ? 200 : max;
      min = min < 0 ? 0 : min;
      temp = temp.slice(min, max);
      let prefix = min > 0 ? '...' : '';
      temp = prefix + temp + '...';
    }
    
    return temp;
  }

  function MarkDown({ data, indexes, selected }) {
    if (indexes.length > 0) {
      let _laudo = data.replace(/(?:\\[rn]|[\r\n])/g, " ");
      let _indexes = [];
      
      const regex = new RegExp(indexes, 'gi');
      _laudo = _laudo.replace(regex, '<mark class="markdown">$&</mark>');
      _indexes.push(_laudo.toLowerCase().indexOf(indexes));

      let limit = _laudo.length > 200 ? 200 : 0;
      const indexMin = Math.min(..._indexes);
      const indexMax = Math.max(..._indexes);

      if (limit > 0 && !selected) {
        let min = indexMin - limit;
        let max = indexMax + limit;
        min = min < 0 ? 0 : min;
        max = max < 200 ? 200 : max;
        _laudo = _laudo.slice(min, max);
        let prefix = min > 0 ? '...' : '';
        _laudo = prefix + _laudo + '...';
      }
      return parse(_laudo);
    }else{
      return parse(setHighLight(data, text, selected));
    }
  }

  function getGender(sigla) {
    switch (sigla) {
      case 'M':
        return <Badge color="info">Masculino</Badge>;
      case 'F':
        return <Badge color="pink">Feminino</Badge>;
      default:
        return <Badge>Não Definido</Badge>;
    }
  }

  function RenderizarFooter({ total }) {
    const [from, setFrom] = useState(0);
    const [all, setAll] = useState(0);

    useEffect(() => {
      if (total > 0 && total < 5) {
        setFrom(total);
        setAll(total);
      } else if (total > 0 && total > 5) {
        let _from = page * 5;
        let _all = Math.ceil(total);
        if (_from > _all && page > 1) {
          _from = _all;
        }
        setFrom(_from);
        setAll(_all);
      } else if (total === 0 || !total) {
        setFrom(0);
        setAll(0);
      }
    });
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItens: 'center',
        }}
      >
        <span
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItens: 'center',
          }}
        >
          <i
            className="mv-basico-stacktrace"
            style={{ fontSize: '20px', height: '18px' }}
          />{' '}
          <span style={{ marginTop: '2px' }} id="total-laudos">
            <IntlMessage id = "dashboards.general.occurrencesReports"/> {from}/<strong>{all}</strong>
          </span>
        </span>
      </div>
    );
  }

  function showPdfInNewTab(base64Data, fileName) {
    const winparams =
      'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
      'resizable,screenX=50,screenY=50,width=850,height=1050';
    const printWindow = window.open('', fileName, winparams);
    setTimeout(() => {
      printWindow &&
        printWindow.document.write(
          `<html><head><title>${fileName}</title></head><body height="100%" width="100%"><iframe title="Preview de impressão de laudo" width='100%' height='100%' src='data:application/pdf;base64, ${encodeURI(
            base64Data
          )}'></iframe></body></html>`
        );
    }, 1000);
    if (
      !printWindow ||
      printWindow.closed ||
      typeof printWindow.closed === 'undefined'
    ) {
      //POPUP BLOCKED
      dispatch(CommonActions.showFadeCarregando(false));
      alert('Favor habilitar no navegador o Pop-up para ter acesso ao Laudo');
    }
  }

  function openLaudo(id) {
    dispatch(CommonActions.showFadeCarregando(true));
    WebapiCommon.baseConhecimentoPdf(id)
      .then((res) => {
        showPdfInNewTab(res.data.pdf, 'laudo:' + id);
        dispatch(CommonActions.showFadeCarregando(false));
      })
      .catch(() => {
        dispatch(CommonActions.showFadeCarregando(false));
      });
  }

  const LoadingOverLay = ({load}) => {
   return load ?
   <div className="loading-overlay">
   <svg id="loading-bar" xmlns="http://www.w3.org/2000/svg" width="36" height="22" viewBox="0 0 36 22">
      <g>
        <rect id="loading-bar-left" width="8" height="22"/>
        <rect id="loading-bar-middle" width="8" height="22" x="14"/>
        <rect id="loading-bar-right" width="8" height="22" x="28"/>
      </g>
    </svg></div>: <React.Fragment />
  }

  return (
    <div>
      <Modal
        size={'lg'}
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        className="baseconhecimento"
      >
        <div>
          <ModalHeader>Base de Conhecimento: {text}</ModalHeader>
          <ModalBody>
            <Row>
              <Colxx xl={6}>
                <div className="patient">
                  <strong>Paciente:</strong>{' '}
                  {selectedLaudo && selectedLaudo.paciente}{' '}
                </div>
                <div className="dtnasc">
                  <strong>Data de Nascimento:</strong>{' '}
                  {selectedLaudo && selectedLaudo.dtNascimento}{' '}
                </div>
                <div className="idade">
                  <strong>Idade:</strong> {selectedLaudo && selectedLaudo.idade}{' '}
                </div>
              </Colxx>
              <Colxx xl={6}>
                <div className="sexo">
                  <strong>Sexo:</strong>{' '}
                  {getGender(selectedLaudo && selectedLaudo.sexo)}{' '}
                </div>
                <div className="prontuario">
                  <strong>Prontuário:</strong>{' '}
                  {selectedLaudo && selectedLaudo.prontuario}{' '}
                </div>
                <div className="nrexame">
                  <strong>Nr Exame:</strong>{' '}
                  {selectedLaudo && selectedLaudo.nrexame}{' '}
                </div>
              </Colxx>
            </Row>
            <div className="medicos">
              <Row>
                <Colxx xl={6}>
                  <div className="medexec">
                    <strong>Médico Executante:</strong>{' '}
                    {selectedLaudo && selectedLaudo.medexecutante}{' '}
                  </div>
                </Colxx>
                <Colxx xl={6}>
                  <div className="medrev">
                    <strong>Médico Revisor:</strong>{' '}
                    {selectedLaudo && selectedLaudo.medrevisor}{' '}
                  </div>
                </Colxx>
              </Row>
            </div>
            <Row>
              <div className="previewlaudo">
                <Colxx xl={12}>
                  {selectedLaudo &&
                  <MarkDown data={selectedLaudo.base64} indexes={text.split(' ')} selected={selectedLaudo} />}
                </Colxx>{' '}
              </div>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => openLaudo(selectedLaudo.id)}>
              Abrir PDF
            </Button>
            <Button color="secondary" onClick={() => setShowModal(!showModal)}>
              Fechar
            </Button>
          </ModalFooter>
        </div>
      </Modal>
      
      <OverlayPanel
        ref={(e) => onRef(e)}
        showCloseIcon={false}
        dismissable={false}
        id="overlay_panel"
        style={{
          width: '450px',
          maxHeight: '90vh',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
        className="overlaypanel"
      >
        <LoadingOverLay load={loading} />
        <DataTable
          className="base-conhecimento-table"
          value={laudos}
          selectionMode="single"
          paginator={laudos && laudos.length >= 1}
          rows={5}
          autoLayout={true}
          emptyMessage={<IntlMessage id = "dashboards.reports.noResultsFound"/>}
          selection={selectedLaudo}
          first={(page - 1) * 5}
          onContextMenu={(e) => {
            setSelectedLaudo(e.data);
          }}
          pageLinkSize={5}
          totalRecords={total}
          lazy={true}
          alwaysShowPaginator={true}
          onPage={(event) => {
            dispatch(Actions.page(event.page + 1));
          }}
          footer={<RenderizarFooter total={total} />}
        >
          <Column
            field="base64"
            header={<IntlMessage id = "dashboards.general.resultSearch"/>}
            body={(props) => {
              const _base64 = props.base64;

              const isContent =
                (text !== '' &&
                  _base64
                    .toLocaleLowerCase()
                    .indexOf(text.toLocaleLowerCase()) >= 0);
              return (
                isContent && (
                  <MarkDown
                    data={_base64}
                    id={props.id}
                    indexes={text}
                  />
                )
              );
            }}
          />
        </DataTable>

        <Row>
          <Colxx xl={6}>
            <Button
              className="mt-3"
              color="primary"
              disabled={!selectedLaudo}
              block
              onClick={() => setShowModal(!showModal)}
            >
              <IntlMessage id = "dashboards.general.toView"/>
            </Button>
          </Colxx>
          <Colxx xl={6}>
            <div>
              <Button
                className="mt-3"
                color="light"
                block
                onClick={() => op.current.hide()}
              >
                <IntlMessage id = "dashboards.examDetail.close"/>
              </Button>
            </div>
          </Colxx>
        </Row>
      </OverlayPanel>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/previewBase/index.js